<div class="rangebox">
    <button data-target="#collapsemeal" data-toggle="collapse" class="collapsebtn" type="button">Meal Plan</button>
    
    
        <div id="collapsemeal" class="collapse show">
            <div class="boxins">
                <ul class="locationul">
                    <li>
                        <div class="squaredThree">
                            <input  type="checkbox" name="check" class="farecheckbox" id="squaredThree19">
                            <label for="squaredThree19"></label>
                        </div>
                        <label class="llbl" for="squaredThree19">Vegtarian</label>
                    </li>
                    <li>
                        <div class="squaredThree">
                            <input  type="checkbox" name="check" class="farecheckbox" id="squaredThree20">
                            <label for="squaredThree20"></label>
                        </div>
                        <label class="llbl" for="squaredThree20">Non-Vegtarian</label>
                    </li>
                    
              </ul>
            </div>
        </div>
    
</div>



